import { X } from "lucide-react";

const DeleteRow = ({ onClose, handleYes, loading }) => {

  return (
    <>
      <div
        className="fixed inset-0 bg-black/50 z-40 transition-opacity"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="fixed inset-0 z-50 flex items-center justify-center ">
        <div className=" rounded-lg  overflow-hidden shadow-2xl w-[90%] md:w-[50%] lg:w-[35%]  bg-white relative">
          {/* Header */}
          <div className="absolute right-3 mt-1">
            <button
              onClick={onClose}
              className="w-9 h-9 bg-white/20 hover:bg-white/30 rounded-full text-lg flex items-center justify-center transition-all hover:rotate-90"
            >
              <X className="w-6 h-6 text-foreground" />
            </button>
          </div>
          <div className="mt-10">
            <p className="text-lg text-center">
              Are you sure want to delete this contact?
            </p>
          </div>
          <div className="flex justify-center gap-x-4 mr-3 mt-6 mb-4">
            <button class="relative inline-flex items-center gap-2 px-10 py-3 font-semibold text-white text-sm rounded-lg bg-gradient-to-r from-gray-300 to-gray-400 shadow-md hover:-translate-y-1 hover:shadow-lg transition duration-300 overflow-hidden group" onClick={onClose}>
              <span class="absolute inset-0 bg-gray-300 rounded-full scale-0 group-hover:scale-150 transition-transform duration-700 ease-out"></span>
              <span class="relative">No</span>
            </button>
            <button
              class="relative inline-flex items-center gap-2 px-10 py-3 font-semibold text-white text-sm rounded-lg bg-gradient-to-b from-[#0f172a] to-[#1E293B] shadow-md hover:-translate-y-1 hover:shadow-lg transition duration-300 overflow-hidden group"
              onClick={handleYes}
            >
              <span class="absolute inset-0 bg-white/20 rounded-full scale-0 group-hover:scale-150 transition-transform duration-700 ease-out"></span>
              {loading ? (
                <svg
                  className="w-5 h-5 text-white animate-spin"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                  ></path>
                </svg>
              ) : (
                <span className="relative">Yes</span>
              )}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeleteRow;
